import { components } from "react-select";
import React from "react";

export const InviteOption = (props) => {
  const { data, selectProps } = props;

  const handleDeleteClick = async (e) => {
    e.preventDefault();
    e.stopPropagation(); // prevent selecting the option

    const email = data.value;

    const confirmed = window.confirm(
      `Remove ${email} from your saved invite list?`
    );
    if (!confirmed) return;

    if (selectProps.onDeleteInvite) {
      try {
        await selectProps.onDeleteInvite(email);
      } catch (err) {
        console.error("Failed to delete invite:", err);
        alert("There was an error removing that email. Please try again.");
      }
    }
  };

  return (
    <components.Option {...props}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span>{data.label}</span>
        <button
          type="button"
          onClick={handleDeleteClick}
          style={{
            border: "none",
            background: "transparent",
            cursor: "pointer",
            fontSize: "14px",
            padding: 0,
          }}
          title="Remove this email from your saved list"
        >
          ✕
        </button>
      </div>
    </components.Option>
  );
};